import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import factory from '~/modules/master/redux/actions/factory'

const useFactory = () => {
  const data = useSelector((state) => get(state, 'master.factory'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(factory, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useFactory
